import { Injectable } from '@angular/core';
import { UrlProviderService } from './local/url-provider.service';
import { HttpinterceptorService } from './httpinterceptor';
import { LookUpData } from '../models/Response/LookUpData';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  public TaxOffices: Array<LookUpData>;

  constructor(private http: HttpinterceptorService, private urlProvider: UrlProviderService) { 
    this.TaxOffices = new Array<LookUpData>();
  }

  public getCountries(): Promise<Array<LookUpData>> {
    var url = this.urlProvider.getCountriesURL();
    return this.http.getRequest(url).toPromise().then((res: Array<LookUpData>) => res)
  }

  public getCities(countryCode:string): Promise<Array<LookUpData>> {
    var url = this.urlProvider.getCities(countryCode);
    return this.http.getRequest(url).toPromise().then((res: Array<LookUpData>) => res)
  }

  public getErps(): Promise<Array<LookUpData>> {
    var url = this.urlProvider.getErpsURL();
    return this.http.getRequest(url).toPromise().then((res: Array<LookUpData>) => res)
  }

  public getUsageTypes(): Promise<Array<LookUpData>> {
    var url = this.urlProvider.getUsageTypesURL();
    return this.http.getRequest(url).toPromise().then((res: Array<LookUpData>) => res)
  }

  public getTaxOffices(): Promise<Array<LookUpData>> {
    var url = this.urlProvider.getTaxOfficesURL();
    return this.http.getRequest(url).toPromise().then((res: Array<LookUpData>) => res)
  }

}
